import SolidBedIcon from 'LuxKit/Icons/solid/SolidBedIcon'
import Modal from 'LuxKit/Modal/Modal'
import { setSvgIconSize } from 'LuxKit/SvgIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import LoyaltyTierBenefitAvailabilityMessageBanner from './LoyaltyTierBenefitAvailabilityMessageBanner'

const IconContainer = styled(Sheet)`
  display: grid;
  place-items: center;
  height: ${rem(32)};
  width: ${rem(32)};
  flex-shrink: 0;
  ${setSvgIconSize(20)}
`

function LoyaltyStayUpgradeBenefitModal() {
  const displayTier = useAppSelector(getLoyaltyDisplayTier)
  const loyaltyProgramName = getLoyaltyProgramDisplayName()

  return <Modal title={<>Upgrade your stay with {loyaltyProgramName}</>}>
    <Group direction="vertical" gap={24}>
      <BodyText variant="large">
        As a {loyaltyProgramName} {getLoyaltyTierDisplayName(displayTier)} member,{' '}
        you've unlocked free upgrades on select hotels
      </BodyText>
      <Sheet padding={12} border="neutral-six" borderRadius="L">
        <Group direction="horizontal" verticalAlign="start" gap={12}>
          <IconContainer background={`tier-${displayTier}-dark`} borderRadius="round">
            <SolidBedIcon />
          </IconContainer>
          <div>
            <BodyText variant="large" weight="bold">Free room upgrades</BodyText>
            <BodyText variant="large">
              Stay in style with upgrades to bigger rooms, better views or premium locations, guaranteed.
            </BodyText>
          </div>
        </Group>
      </Sheet>
      <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="hotel_upgrade" />
    </Group>
  </Modal>
}

export default LoyaltyStayUpgradeBenefitModal
